import React, { FC, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import _ from 'lodash';
import { addComma } from 'src/utils/common';
import { dateFormat } from 'src/utils/dateSet';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { deleteNtsFileFn } from 'src/fetch/stepC/settlement';
import { getMemberInfo } from 'src/utils/common';
import {
  settlementNtsDataStore,
  ntsFileDataStore,
  settlementDataStore,
} from 'src/store/settlementInfo';

export const gridOption = (data: any, totalCount: number, bindStateData: any) => {
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  // const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const userInfoData: any = getMemberInfo();

  // 정산결과(NTS)
  const ntsInfoBindParam = settlementNtsDataStore((state: any) => state.bindParam);
  const ntsInfoParam = settlementNtsDataStore((state: any) => state.param);
  // 정산결과
  const settlementBindParam = settlementDataStore((state: any) => state.bindParam);
  const settlementParam = settlementDataStore((state: any) => state.param);
  // NTS 업로드파일 데이터
  const ntsFileBindParam = ntsFileDataStore((state: any) => state.bindParam);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);

  const gridData = _.cloneDeep(data) || [];
  const disableEvent = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  const gridFnc = {
    viewContent: (param: any) => {
      const docSeq = param[0];
      const setParam = userInfoData;
      setParam.doc_seq = docSeq;

      const downloadEvt = (e: any) => {};

      const deleteEvt = (selItem: any) => {
        const confirmDiv = () => {
          return (
            <div className="_confirm_modal_content">
              <div className="_title">해당 내용을 삭제합니다.</div>
              <div className="_desc">내용을 삭제 하시겠습니까?</div>
            </div>
          );
        };
        setConfirmModalState({
          active: '_active',
          content: confirmDiv(),
          cancleEvt: (item: any) => {
            closeModalState({ content: null, active: '' });
          },
          confirmEvt: (item: any) => {
            deleteNtsFileFn(setParam, queryClient, errorModalState, loadingState, () => {
              // Init
              const initialSeq = settlementParam.initialSeq || 0;
              settlementBindParam({ initialSeq: initialSeq + 1 });
              const initialNtsSeq = ntsInfoParam.initialSeq || 0;
              ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
              const initialFileSeq = ntsFileParam.initialSeq || 0;
              ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

              closeModalState({ content: null, active: '' });
            });
          },
        });
      };
      // const deleteEvt = (e: any) => {
      //   deleteNtsFileFn(setParam, queryClient, errorModalState, loadingState, () => {
      //     // Init
      //     const initialSeq = settlementParam.initialSeq || 0;
      //     settlementBindParam({ initialSeq: initialSeq + 1 });
      //     const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      //     ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      //     const initialFileSeq = ntsFileParam.initialSeq || 0;
      //     ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      //     setContentModalState({
      //       active: '',
      //     });
      //   });
      // };
      return (
        <div className="_custom_div_right" style={{ width: '100px' }}>
          {/* <div className="_r_btn">
            <IconButton
              icon="ri-download-2-line"
              clickEvent={downloadEvt}
              type="type3"
              styleDef={{
                width: '28px',
                height: '28px',
                fontSize: '16px',
              }}
            />
          </div> */}
          <div className="_r_btn">
            <IconButton
              icon="ri-delete-bin-2-line"
              clickEvent={deleteEvt}
              type="type3"
              styleDef={{
                width: '28px',
                height: '28px',
                fontSize: '16px',
              }}
            />
          </div>
        </div>
      );
    },
    createDate: (param: any) => {
      return dateFormat(param[0], 'YYYY.MM.DD HH:mm');
    },
    viewCount: (param: any) => {
      const count = param[0] || 0;
      return addComma(count);
    },
  };

  //   {
  //     "doc_seq": "2025011001650267",
  //     "file_path": "\\data\\nts\\storage\\2024\\0001\\d4656fe2-7f40-45fd-8f98-387c85de4901_고길동(750101)-2024년도자료.pdf",
  //     "co_cd": "0001",
  //     "co_id": "testpdf",
  //     "acct_year": "2024",
  //     "doc_type": "A",
  //     "org_name": "고길동(750101)-2024년도자료.pdf",
  //     "saved_name": "d4656fe2-7f40-45fd-8f98-387c85de4901_고길동(750101)-2024년도자료.pdf",
  //     "file_size": 821790
  // }

  // gridData
  const gridOption = {
    label: [
      {
        label: '',
        col: 'id',
        width: '0px',
        align: 'left',
        useYN: 'none',
      },
      {
        label: '순번',
        col: 'num',
        width: '50px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
      },
      {
        label: '문서종류',
        col: 'doc_type',
        width: '100px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
      },
      {
        label: '파일명',
        col: 'org_name',
        width: 'calc(100% - 300px)',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
      },
      // {
      //   label: '대상자',
      //   col: 'recipient',
      //   width: '100px',
      //   align: 'center',
      //   sort: { use: false, active: true, status: 'desc' },
      // },
      {
        label: '',
        col: '',
        width: '150px',
        align: 'center',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewContent, param: ['doc_seq'] },
      },
    ],
    styleDef: { width: '100%', fontSize: '13px' },
    data: gridData,
    totalCount: totalCount,
  };

  return gridOption;
};
